// File: cgp-user-profile-dialog-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile module.
// Other Contributors:
import { CommonModule, DatePipe } from '@angular/common';

import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
//import { AppModule } from '../../app.module';

import { CgpUserProfileDialogComponent } from "./cgp-user-profile-dialog.component";
import { CgpUserProfileDialogService } from "./cgp-user-profile-dialog.service";
import { UserProfileService } from '../../components/mesc/mesc.service';
import { PipesModule } from '../pipes/pipes.module';

//import { UserProfileComponent } from '../../user-profile/user-profile.component';

@NgModule({
    imports: [
        MatDialogModule, MatButtonModule, CommonModule, PipesModule
        //, AppModule
    ],
    exports: [
        CgpUserProfileDialogComponent
    ],
    declarations: [
        CgpUserProfileDialogComponent
    ],
    providers: [
        CgpUserProfileDialogService, UserProfileService, DatePipe
    ]
})
export class CgpUserProfileDialogModule { }
